import { createContext, useContext } from "react";

export type InsertFn = (token: string) => void;

type VariavelInsertContextValue = {
  /**
   * Registra o campo de texto em foco como alvo das variáveis. `canalId`
   * acompanha porque o mapa de variáveis é por canal: inserir `{{nome}}`
   * no texto do e-mail precisa declarar a variável no template do e-mail,
   * não no do SMS.
   */
  registerActiveInsert: (canalId: string, insert: InsertFn) => void;
};

// Contexto que liga a sidebar de variáveis (uma só, para a tela inteira) a
// qualquer campo de mensagem focado no momento (RichTextEditor, textarea de
// SMS ou o valor de um parâmetro de template externo). Cada campo se
// registra como "alvo ativo" ao ganhar foco; a sidebar insere sempre no
// último campo registrado.
export const VariavelInsertContext = createContext<VariavelInsertContextValue>({
  registerActiveInsert: () => {},
});

export const useVariavelInsert = () => useContext(VariavelInsertContext);
